export abstract class PopularLocationsRepository {
  abstract fetch(langCode: string, limit?: number): Promise<any>
}
